<template>
  <b-container fluid>
    <loading :active.sync="isGenerando" :is-full-page="true"></loading>
    <b-row class="margin" align-h="center" no-gutters>
      <b-col cols="12" >
       
         
        <b-row align-h="center" align="center" no-gutters>
          <b-col cols="12" lg="12">  
            <b-alert variant="danger" dismissible @dismissed="cleanMsgError" :show="msgErrorContribuyente != ''">
              {{msgErrorContribuyente}}
            </b-alert>
          </b-col>
        </b-row>

        <b-row class="mt-3" align="center" align-h="center" no-gutters v-if="(pdfsGenerated==null || pdfsGenerated.length==0) && isPublico">
          <b-col cols="12" ><br><h5>Seleccione el documento que desea facturar</h5><br></b-col>  
          <b-col cols="12" >
            <b-form-radio-group v-model="tipoDocumento">
              <b-form-radio class="margin-radio-recibo" value="recibo">Recibo de Pago</b-form-radio><b class="b-icon-info-recibo" title="Más información"><b-icon icon="question-circle-fill" font-scale="1" variant="success" ></b-icon></b>
              <b-form-radio class="margin-radio-linea" value="formato">Formato Único de Pago </b-form-radio><b title="Más información"><b-icon icon="question-circle-fill" font-scale="1" variant="success" ></b-icon></b>
            </b-form-radio-group>
          </b-col>
        </b-row>

       
        <!----------     DATOS DE BUSQUEDA  ------------>
        <b-row align-h="center" v-if="(pdfsGenerated ==null || pdfsGenerated.length==0) && tipoDocumento!=null && isPublico" > 
          
          <b-col cols="12" class="mt-3">
            <b-row align-h="center" align="center" > 
              <b-col v-if="tipoDocumento=='formato'" cols="12" ><br><h5>Formato Único de Pago</h5><br></b-col>  
              <b-col v-if="tipoDocumento=='recibo'" cols="12" ><br><h5>Recibo de Pago</h5><br></b-col>  
            </b-row>
          </b-col>

          <b-col cols="10"  v-if="tipoDocumento=='recibo'">
            <b-form-group>
              <a>Serie:</a> <b title="Más información"><b-icon icon="question-circle-fill" font-scale="1" variant="success" @click="isShowInfoSerie=true"></b-icon></b><br>
              <b-form-input class="input-serie" :state="!$v.serieRecibo.$invalid" type="text" v-model.trim="serieRecibo"></b-form-input>
              <div class="error" v-if="!$v.serieRecibo.minLength">La Serie debe contener dos carecteres. Ejemplo 'LA'.</div>
              <div class="error" v-if="!$v.serieRecibo.maxLength">La Serie debe contener dos carecteres. Ejemplo 'LA'.</div>
              <div class="error" v-if="!$v.serieRecibo.required">Ingrese una serie de dos caracteres.</div>            
            </b-form-group>
          </b-col>
          <b-col cols="10"  v-if="tipoDocumento=='formato'">
            <b-form-group>
              <a>Serie:</a> <b title="Más información"><b-icon icon="question-circle-fill" font-scale="1" variant="success" @click="isShowInfoSerie=true"></b-icon></b><br>
              <b-form-input class="input-serie" :state="!$v.seriePagoRef.$invalid" type="text" v-model.trim="seriePagoRef"></b-form-input>
              <div class="error" v-if="!$v.seriePagoRef.minLength">La Serie debe contener tres carecteres. Ejemplo 'OAC'.</div>
              <div class="error" v-if="!$v.seriePagoRef.maxLength">La Serie debe contener tres carecteres. Ejemplo 'OAC'.</div>
              <div class="error" v-if="!$v.seriePagoRef.required">Ingrese una serie de tres caracteres.</div>
            </b-form-group>
          </b-col>
          <b-col cols="10" >
            <b-form-group>
              <a>Folio:</a> <b title="Más información"><b-icon icon="question-circle-fill" font-scale="1" variant="success" @click="isShowInfoFolio=true"></b-icon></b><br>
              <b-form-input class="input-folio" :state="!$v.folio.$invalid" type="text" v-model.trim="folio"></b-form-input>     
              <div class="error" v-if="!$v.folio.required || !$v.folio.minLength || !$v.folio.maxLength">Ingrese un Folio de 6 dígitos.</div>
            </b-form-group>
          </b-col>
          <b-col cols="10" >
            <b-form-group>
              <a>Total Pagado:</a> <b title="Más información"><b-icon icon="question-circle-fill" font-scale="1" variant="success" @click="isShowInfoTotal=true"></b-icon></b><br>
              <b-form-input :state="!$v.total.$invalid" type="number" v-model.trim="total"></b-form-input>     
              <div class="error" v-if="!$v.total.required">Ingrese el Total Pagado sin comas ni espacios.</div>
              <div class="error" v-if="!$v.total.between">La cantidad debe ser mayor a 1.</div>         
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-row v-show="tipoDocumento != null" align-h="center" align="center">
              <b-col cols="12" >
                <vue-recaptcha ref="recaptchaFacturacion" sitekey="6LdD09sUAAAAANCvTN2xMZqvfMOvzkdkOB1Zcpok" @verify="captchaFacturacionFilled" @expired="captchaFacturacionExpired" :loadRecaptchaScript="true" />
              </b-col>
              <b-col cols="12">
                <div class="error" v-if="isShowMsgCaptcha">Por favor complete el captcha.</div><br>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="10" class="mb-5">
            <b-button block size="lg" variant="success" @click="consultaDocOficial" :disabled="this.captchaFacturacion==null">Consultar <b-icon icon="arrow-right-circle"/></b-button>
            
          </b-col>
        </b-row>


        <!----------     DOCUMENTOS   ------------>
        <b-row align-h="center" v-if="pdfsGenerated!=null">
          <b-col cols="12">
            <b-tabs content-class="mt-3">
              <b-tab v-for="pdfGenerated in pdfsGenerated" :key="pdfGenerated.nombre">
                <template #title>
                  <b-icon icon="file-earmark-ruled-fill"/> {{pdfGenerated.nombre}}
                </template>
                <b-embed id="embed1" type="iframe" :src="'data:application/pdf;base64,' + pdfGenerated.b64"></b-embed>

                <!-------- Descargar pdf ----------->
                <b-row>
                    <b-col cols="12">
                        <b-button block variant="warning" @click="downloadPdf(pdfGenerated.b64, pdfGenerated.nombre)" size="lg">Descargar pdf <b-icon icon="download"/> </b-button>
                    </b-col>
                </b-row>
                <!--------- Facturar recibo-------------->
                <b-row cols="12" class="mt-3 mb-3" v-if="pdfGenerated.nombre.includes('ecibo') && pdfGenerated.meta!=null">
                    <b-col cols="12">
                      <b-button block variant="success" v-b-toggle.collapse-fact size="lg" v-if="refactura">Refacturar recibo <b-icon icon="file-spreadsheet"/> </b-button>
                      <b-button block variant="success" v-b-toggle.collapse-fact size="lg" v-if="!refactura">Facturar recibo <b-icon icon="file-spreadsheet"/> </b-button>
                      <b-collapse id="collapse-fact" >
                        <b-col cols="12">
                          <b-row align="center" align-h="center" no-gutters>
                            <b-col cols="12" ><br><h5>Ingrese sus datos fiscales</h5><br></b-col>  
                          </b-row>
                        </b-col>

                        <b-col cols="12" >
                          <b-form-group label="Nombre o Razón Social:">
                            <b-form-input :state="!$v.nombre.$invalid" type="text" v-model.trim="nombre" :disabled="!editable"></b-form-input>
                            <div class="error" v-if="!$v.nombre.minLength">El Nombre es demasiado corto.</div>
                            <div class="error" v-if="!$v.nombre.maxLength">El Nombre es demasiado largo.</div>
                            <div class="error" v-if="!$v.nombre.required">Ingrese un Nombre válido.</div>
                            <div class="error" v-if="!editable&&tokenUser==null">Para actualizar su Nombre, comuníquese a la oficina recaudadora.</div>
                          </b-form-group>
                        </b-col>
                        <b-col cols="12" >
                          <b-input-group label="RFC:">
                            
                            <b-form-input :state="!$v.rfc.$invalid" type="text" v-model.trim="rfc" :disabled="!editable"></b-form-input>
                            <b-input-group-prepend v-if="editable && rfc!=null && rfc.length>11 && rfc.toUpperCase()!='XAXX010101000' && tokenUser!=null" is-text><b-icon icon="search" style="cursor:pointer;" @click="datosFacturacion()"></b-icon></b-input-group-prepend>
                            <div class="error" v-if="!$v.rfc.minLength">El RFC es demasiado corto.</div>
                            <div class="error" v-if="!$v.rfc.maxLength">El RFC es demasiado largo.</div>
                            <div class="error" v-if="!$v.rfc.required">Ingrese un RFC válido.</div>
                            <div class="error" v-if="!editable&&tokenUser==null">Para actualizar su RFC, comuníquese a la oficina recaudadora.</div>
                          </b-input-group>
                          
                        </b-col>
                        <b-col cols="12" >
                          <b-form-group label="Régimen Fiscal:">
                            <b-form-select :state="!$v.regimen.$invalid"  v-model.trim="regimen" :options="tipoRegimenOptions"></b-form-select>
                          </b-form-group>
                        </b-col>
                        <b-col cols="12" >
                          <b-form-group label="Código Postal:">
                            <b-form-input :state="!$v.cp.$invalid" type="text" v-model.trim="cp"></b-form-input>
                            <div class="error" v-if="!$v.cp.minLength">El Código Postal es demasiado corto.</div>
                            <div class="error" v-if="!$v.cp.maxLength">El Código Postal es demasiado largo.</div>
                            <div class="error" v-if="!$v.cp.required">Ingrese su Código Postal.</div>
                          </b-form-group>
                        </b-col>
                        <b-col cols="12" >
                          <b-form-group label="Email:">
                            <b-form-input :state="!$v.email.$invalid" type="text" v-model.trim="email"></b-form-input>
                            <div class="error" v-if="!$v.email.minLength">Email demasiado corto.</div>
                            <div class="error" v-if="!$v.email.maxLength">Email demasiado largo.</div>
                          </b-form-group>
                        </b-col>
                        <b-col cols="12">
                          <b-form-group label="Forma de Pago:">
                            <b-form-select type="text" :state="!$v.formaPago.$invalid"  :options="optionsFormaPago" v-model="formaPago"></b-form-select>
                          </b-form-group>
                        </b-col>
                        <b-col cols="12" >
                          <b-form-group label="Método de Pago:">
                            <b-form-select type="text" :state="!$v.metodoPago.$invalid"  :options="optionsMetodoPago" v-model="metodoPago"></b-form-select>
                          </b-form-group>
                        </b-col>
                        
                        <b-col cols="12">
                          <b-row align-h="center" align="center" no-gutters>
                            <b-col cols="12" lg="12">  
                              <b-alert variant="danger" dismissible @dismissed="cleanMsgError" :show="msgErrorContribuyente != ''">
                                {{msgErrorContribuyente}}
                              </b-alert>
                            </b-col>
                          </b-row>
                        </b-col>
                        <b-col cols="12">
                          <b-row>
                            <b-col cols="10">
                              <b-button block size="lg" variant="warning" @click="facturar">
                                <b-spinner v-if="isGenerando"></b-spinner>
                                <strong v-if="isGenerando"> Facturando . . .</strong>
                                <strong v-if="!isGenerando"> Facturar</strong>
                              </b-button>
                            </b-col>
                          </b-row><br>
                          <b-row>
                            <b-col id="column-links">
                            </b-col>
                          </b-row>
                        </b-col>

                        
                      </b-collapse> 
                    </b-col>
                </b-row>

                <!-------------- Descargar XML----------------->
                <b-row cols="12" class="mt-3 mb-3" v-if="pdfGenerated.nombre.includes('actura') && pdfGenerated.meta!=null && pdfGenerated.meta.xml!=null">
                    <b-col cols="12">
                      <b-button block variant="info" size="lg" @click="downloadXml(pdfGenerated.meta.xml)">Descargar xml <b-icon icon="file-code"/> </b-button>
                    </b-col>
                </b-row>

                <!------ Cancelar  ------->
                <b-row cols="12" class="mt-3 mb-3" v-if="pdfsGenerated!= null && pdfsGenerated.length>0 && isPublico">
                  <b-col cols="12">
                  <b-button block size="lg" variant="secondary" @click="$store.commit('updatePdfsGenerated', [])">
                    <strong > Salir</strong>
                  </b-button>                    
                  </b-col>
                </b-row>
                  

              </b-tab>
            </b-tabs>
          </b-col>

          
        </b-row>
        
        
        
      </b-col>
    </b-row>

    <!--------------------------------------------------------------------- MODALS -------------------------------------------------------------------->

   

    <b-modal title="Información" v-model="isShowInfoFacLinea" size="sm" hide-footer>
      Seleccione esta opción si usted cuenta con un Formato Único de Pago y realizó el pago en alguno de los establecimientos externos autorizados y han trascurrido más de 72 horas.
    </b-modal>

    <b-modal title="Información" v-model="isShowInfoFacRecibo" size="sm" hide-footer>
      Seleccione esta opción si usted realizó el pago en las oficinas administrarivas municipales y cuenta con un recibo oficial de pago.
    </b-modal>

    <b-modal title="Información" v-model="isShowInfoFolio" size="md" hide-footer>
      <b-row class="success" align-h="center">
        El Folio es un dato númerico.
      </b-row>
      <b-row class="row-to-img-orden" align-h="center">
        <b-img src="/imgs/orden_ico.jpg" width="400px"></b-img>
      </b-row>
    </b-modal>

    <b-modal title="Información" v-model="isShowInfoSerie" size="md" hide-footer>
      <b-row class="success" align-h="center">
        La Serie consta de tres caracteres.
      </b-row>
      <b-row class="row-to-img-orden" align-h="center">
        <b-img src="/imgs/orden_ico.jpg" width="400px"></b-img>
      </b-row>
    </b-modal>

    <b-modal title="Información" v-model="isShowInfoMonto" size="md" hide-footer>
      <b-row class="success" align-h="center">
        <!--Debe ingresar el total a pagar que aparece en el formato de pago.-->
        El Total a Pagar no debe contener comas ni signos de pesos.
      </b-row>
      <b-row class="row-to-img-orden" align-h="center">
        <b-img src="/imgs/orden_ico.jpg" width="400px"></b-img>
      </b-row>
    </b-modal>

    <b-modal title="Información" v-model="isShowInfoTotal" size="md" hide-footer>
      <b-row class="success" align-h="center">
        <!--Debe ingresar el total a pagar que aparece en el formato de pago.-->
        El Total Pagado no debe contener comas ni signos de pesos.
      </b-row>
      <b-row class="row-to-img-orden" align-h="center">
        <b-img src="/imgs/orden_ico.jpg" width="400px"></b-img>
      </b-row>
    </b-modal>
  </b-container>
</template>


<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { minLength, maxLength, required, decimal, between } from 'vuelidate/lib/validators';
import { mapState} from 'vuex';
import { server, getPostConfig, getGetConfig, handledError } from '@/axios-tools';
import { downloadB64Pdf, generarTxtFileUtf8 } from '@/vue-tools'
import axios from 'axios';
import VueRecaptcha from 'vue-recaptcha';
import Vue from 'vue';
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue';
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)

export default {
  computed:{
    ...mapState({
      isGenerando: state => state.contribuyente.isGenerando,
      pdfsGenerated: state => state.cobro.pdfsGenerated,
      msgErrorContribuyente: state => state.contribuyente.msgErrorContribuyente,
      thems: state => state.contribuyente.catalogContribuyente.thems,
    }),
    token:{
      get(){return this.metaRecibo == null ? null : this.metaRecibo.token},
      set(v){ if(this.metaRecibo!=null){this.metaRecibo.token = v;} }
    },
    nombre:{
      get(){return this.metaRecibo == null ? null : this.metaRecibo.nombre},
      set(v){ if(this.metaRecibo!=null){this.metaRecibo.nombre = v;} }
    },
    refactura:{
      get(){return this.metaRecibo == null ? null : this.metaRecibo.refactura},
      set(v){ if(this.metaRecibo!=null){this.metaRecibo.refactura = v;} }
    },
    rfc:{
      get(){return this.metaRecibo == null ? null : this.metaRecibo.rfc},
      set(v){ if(this.metaRecibo!=null){this.metaRecibo.rfc = v;} }
    },
    regimen:{
      get(){return this.metaRecibo == null ? null : this.metaRecibo.regimen},
      set(v){ if(this.metaRecibo!=null){this.metaRecibo.regimen = v;} }
    },
    formaPago:{
      get(){return this.metaRecibo == null ? null : this.metaRecibo.formaPago},
      set(v){ if(this.metaRecibo!=null){this.metaRecibo.formaPago = v;} }
    },
    metodoPago:{
      get(){return this.metaRecibo == null ? null : this.metaRecibo.metodoPago},
      set(v){ if(this.metaRecibo!=null){this.metaRecibo.metodoPago = v;} }
    },
    cp:{
      get(){return this.metaRecibo == null ? null : this.metaRecibo.cp},
      set(v){ if(this.metaRecibo!=null){this.metaRecibo.cp = v;} }
    },
    email:{
      get(){return this.metaRecibo == null ? null : this.metaRecibo.email},
      set(v){ if(this.metaRecibo!=null){this.metaRecibo.email = v;} }
    },
    padron:{
      get(){return this.metaRecibo == null ? null : this.metaRecibo.padron},
      set(v){ if(this.metaRecibo!=null){this.metaRecibo.padron = v;} }
    },
    recibo:function(){
      if(this.pdfsGenerated==null){return null}
      for(var i=0; i<this.pdfsGenerated.length; i++){
        if(this.pdfsGenerated[i].nombre.includes('ecibo')){
          return this.pdfsGenerated[i];
        }
      }
      return null;
    },
    metaRecibo:function(){
      if(this.recibo==null){return null}
      return this.recibo.meta;
    },
    editable:function(){
      return this.metaRecibo.cNombreFactura;
    }

  },
  data(){
    return{
     
     // regimen:"601 - General de Ley Personas Morales",
      //formaPago:"Efectivo",
      
      captchaFacturacion:null,
      isShowMsgCaptcha:false,
      optionsFormaPago:["Efectivo", "Cheque", "Transferencia", "Crédito", "Débito", "Por definir", "Dación en pago", "Compensación"],
      optionsMetodoPago:["PUE - Una exhibición", "PPD - Parcialidades" ],
      tipoRegimenOptions:["601 - General de Ley Personas Morales","603 - Personas Morales con Fines no Lucrativos","605 - Sueldos y Salarios e Ingresos Asimilados a Salarios",	"606 - Arrendamiento","607 - Régimen de Enajenación o Adquisición de Bienes",	"608 - Demás ingresos",	"610 - Residentes en el Extranjero sin Establecimiento Permanente en México",	"611 - Ingresos por Dividendos (socios y accionistas)",	"612 - Personas Físicas con Actividades Empresariales y Profesionales",	"614 - Ingresos por intereses",	"615 - Régimen de los ingresos por obtención de premios",	"616 - Sin obligaciones fiscales","620 - Sociedades Cooperativas de Producción que optan por diferir sus ingresos","621 - Incorporación Fiscal","622 - Actividades Agrícolas, Ganaderas, Silvícolas y Pesqueras",	"623 - Opcional para Grupos de Sociedades","624 - Coordinados",	"625 - Régimen de las Actividades Empresariales con ingresos a través de Plataformas Tecnológicas","626 - Régimen Simplificado de Confianza"],
      isShowInfoFacRecibo: false,
      isShowInfoFacLinea:false,
      isShowInfoSerie:false,
      isShowInfoFolio:false,
      isShowInfoMonto:false,
      isShowInfoTotal:false,

      serieRecibo:"", 
      seriePagoRef:"", 
      folio:"", 
      total:"", 
      tipoDocumento:null,

      tokenInUrl:null
    }
  },
  props:['isPublico', 'tokenUser'],
  components: {
    VueRecaptcha,
    Loading
  },
   created: function () {
   
    //Se obtienen los datos de la url 
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    this.serieRecibo=urlParams.get('serie');
    this.folio=urlParams.get('folio');
    this.total=urlParams.get('total');
    this.tokenInUrl=urlParams.get('token');

    this.captchaFacturacion=null;
    this.tipoDocumento='recibo'

    this.consultaDocOficial();
    
  },
  methods:{
    facturar(){
      if( !this.$v.nombre.$invalid &&
          !this.$v.rfc.$invalid &&
          !this.$v.regimen.$invalid &&
          !this.$v.formaPago.$invalid &&
          !this.$v.metodoPago.$invalid &&
          !this.$v.cp.$invalid &&
          !this.$v.email.$invalid &&
          !this.isGenerando){

        
          this.$store.commit("updateIsGenerandoContribuyente", true);
          this.cleanMsgError();
          axios(
            getPostConfig(
              server.facturarRecibo, 
              {
                nombre:this.nombre,
                rfc:this.rfc, 
                regimen:this.regimen, 
                cp:this.cp, 
                formaPago:this.formaPago,
                email:this.email,
                metodoPago:this.metodoPago,
                token : this.token,
              },            
              this.tokenUser, 
              {
                codeClient:this.$route.params.municipio
              })
          )
          .then(res => {
            //this.downloadPdfAndXml(res.data);
             this.$store.commit("updatePdfsGenerated", res.data);
            this.$store.commit("updateIsGenerandoContribuyente", false);
          }).catch(err => {
            handledError(err, server.facturarRecibo, this.$router, this.$store);
            this.$store.commit("updateIsGenerandoContribuyente", false);
          });
      }
    },
    datosFacturacion(){
      if( 
          !this.$v.rfc.$invalid &&
          !this.isGenerando){

        
          this.$store.commit("updateIsGenerandoContribuyente", true);
          this.cleanMsgError();
          axios(
            getGetConfig(
              server.datosFacturacion, 
              null,            
              null, 
              {
                codeClient:this.$route.params.municipio,
                rfc:this.rfc
              })
          )
          .then(res => {
            this.cp = res.data.cpReceptor;
            this.nombre = res.data.razonSocial
            this.regimen =  res.data.regFiscal
            this.email = res.data.email.emailSet

            this.$store.commit("updateIsGenerandoContribuyente", false);
          }).catch(() => {
            this.$store.commit("updateIsGenerandoContribuyente", false);
            alert("No se encontraron datos registrados del RFC "+this.rfc);
          });
      }
    },
    consultaDocOficial(){
      var serie = this.tipoDocumento == 'formato' ? this.seriePagoRef : this.serieRecibo;
      var token = this.tokenInUrl !=null? this.tokenInUrl : this.token;
      var inValidSerie = this.tipoDocumento == 'formato' ? this.$v.seriePagoRef.$invalid : this.$v.serieRecibo.$invalid;
      if( !inValidSerie && !this.$v.folio.$invalid && !this.$v.total.$invalid && !this.isGenerando){
        if((this.tokenInUrl !=null || this.captchaFacturacion != null)){
          
          this.$store.commit("updateIsGenerandoContribuyente", true);
          
          this.cleanMsgError();
          
          
          axios(
            getGetConfig(server.consultaDoc, null, null, {token: token, serie:serie,folio:this.folio,codeClient:this.$route.params.municipio,captcha:this.captchaFacturacion, total:this.total, isOrdenPago:this.tipoDocumento=='formato'})
          )
          .then(res => {
            this.$store.commit("updatePdfsGenerated", res.data);
            this.$store.commit("updateIsGenerandoContribuyente", false);
            this.captchaFacturacion = null;
            this.$refs.recaptchaFacturacion.reset();
            
          }).catch(err => {
            handledError(err, server.consultaDoc, this.$router, this.$store);
            this.captchaFacturacion = null;
            this.$refs.recaptchaFacturacion.reset();
            this.$store.commit("updateIsGenerandoContribuyente", false);
          });
        }else{
          this.isShowMsgCaptcha = true;
        }
      }
    },
    cleanMsgError(){
      /* Se manda cadena vacia a MsgErrorContribuyente en el store, ya que el <b-alert> para mostrar errores solo se muestra si este es diferente de cadena vacia */
      this.$store.commit("updateMsgErrorContribuyente", '');
    },
    captchaFacturacionFilled(token){
      this.captchaFacturacion = token;
      this.isShowMsgCaptcha = false;
    },
    captchaFacturacionExpired(){
      this.captchaFacturacion = null;
    },
    cleanResults(){
      /* Limpia toda la información de la liquidación en el store, cuando se manda una nueva petición */
      this.$store.commit("updateMsgErrorContribuyente", '');
      this.isShowMsgCaptcha = false;
    },
    cleanCaptchas(){
      /* Una vez que se ha enviado una petición 'consultaadeudo', es necesario limpiar los token(captcha), ya que solo son validos para una petición */
      this.captchaFacturacion = null;
      /* Despues de limpiar los token, para que un usuario pueda solicitar un nuevo token se resetean los captcha */
      if(this.$refs.recaptchaFacturacion!= null){ this.$refs.recaptchaFacturacion.reset();}
    },
    downloadPdf(pdfGenerated, nombre){
        downloadB64Pdf(pdfGenerated, nombre);
    },
    downloadXml(xml){
       generarTxtFileUtf8("cfdi", xml, "xml")
    }
  },
  validations:{
    serieRecibo:{
            required,
            minLength: minLength(2),
            maxLength: maxLength(2)
    },
    seriePagoRef:{
            required,
            minLength: minLength(3),
            maxLength: maxLength(3)
    },
    total:{
            required,
            decimal,
            between: between(1.00, 999999999.99)
    },
    folio:{
            required,
            minLength: minLength(6),
            maxLength: maxLength(6)
    },
    rfc:{
            required,
            minLength: minLength(12),
            maxLength: maxLength(13)
    },
    nombre:{
            required,
            minLength: minLength(1),
            maxLength: maxLength(199)
    },
    cp:{
            required,
            minLength: minLength(5),
            maxLength: maxLength(5)
    },
    email:{
            
            minLength: minLength(5),
            maxLength: maxLength(200)
    },
    formaPago:{
            required,
    },
    metodoPago:{
            required,
    },
    regimen:{
            required,
    },
  }
}
</script>
<style>
.row-to-img-orden{
  margin-left:40px;
}
.button-reenviar{
  margin-top: 5px;
}
.dropdown{
  margin-bottom: 5px;
}
.input-folio{
  margin-top:10px;
}
.input-serie{
  margin-top:10px;
}
.b-icon-info-recibo{
  margin-right:20px;
}
.margin-radio-recibo{
  margin-right:5px;
}
.margin-radio-linea{
  margin-right:5px;
}
.link-pdf{
  margin-left:20px;
}
.margin{
  margin: 5px auto;
}
div.error{
  color: red;
}
div.success{
  color: green;
  margin-bottom: 10px;
}

/*------------------------------------------------------------------------------- THEMS -------------------------------------------------------------------------- */
.teotihuacan:hover{
   background-color:#A03455;
   border-color:#A03455;
}
.teotihuacan{
   background-color:#9D2449; 
   border-color:#9D2449;
}
.demo:hover{
  background-color:#5F58B1;
   border-color:#5F58B1;
}
.demo{
  background-color:#312991; 
   border-color:#312991;
}
.pagoenlinea-modal .modal-dialog {
    height:100% !important;
    
}
</style>